import React, { useState } from 'react';

import { Button, Checkbox, Container, Grid, IconButton, Input, InputAdornment, ListItemText, makeStyles, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import { CropSquare, Stop, StopOutlined } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  chkBoxSvg: {
    '& path': {
      outline: '3px solid rgba(0, 0, 0, 0.54)',
    },
  },
  container: {
    padding: theme.spacing(3),
    paddingLeft: 0,
  },
  controlsContainer: {
    marginTop: theme.spacing(2),
  },
}));

export default ({ onCreateWorkspace, onCriteriaChange }) => {
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [keyword, setKeyword] = useState('');
  const classes = useStyles();
  const onFilterChange = (event) => {
    setSelectedFilter(event.target.value);
    const isRecentlyAdded = event.target.value !== 'All';
    onCriteriaChange({ isRecentlyAdded: isRecentlyAdded || null });
  };

  const onSearchChange = (event) => {
    setKeyword(event.target.value);
  };
  const onSearchClick = () => {
    onCriteriaChange({ keyword, page: 0 });
  };

  const renderCreateButton = () => (
    <Grid item>
      <Button color="primary" style={{ marginLeft: '2rem' }} variant="contained" size="medium" onClick={onCreateWorkspace}>
        Create Workspace
      </Button>
    </Grid>
  );

  const renderSearchInput = () => (
    <Grid item container xs={3}>
      <TextField
        onChange={onSearchChange}
        placeholder="Search"
        onKeyUp={(evt) => {
          if (evt.key === 'Enter') {
            onSearchClick();
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment>
              <IconButton onClick={onSearchClick}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        type="text"
      />
    </Grid>
  );
  const renderFilterDropdown = () => (
    <Grid container item alignItems="center" xs={4}>
      <Typography>View:</Typography>
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        value={selectedFilter}
        onChange={onFilterChange}
        input={<Input disableUnderline />}
        renderValue={(selected) => selected}
        MenuProps={{
          anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom',
          },
          getContentAnchorEl: null,
        }}>
        {['All', 'Recently Added'].map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={selectedFilter === name} color="primary" />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
  return (
    <div className={classes.container}>
      <Typography variant="h4" align="left" className="page-header pb-1">
        Workspaces
      </Typography>
      <Grid container className={classes.controlsContainer}>
        <Grid container item xs={6}>
          {renderFilterDropdown()}
          {renderSearchInput()}
          {renderCreateButton()}
        </Grid>
      </Grid>
    </div>
  );
};
